import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Slot } from "@radix-ui/react-slot";
import type { LucideIcon } from "lucide-react";
import { Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
interface IconCardProps {
  icon?: LucideIcon;
  title: string;
  description: React.ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
  trend?: React.ReactNode;
}
export function IconCard(t0) {
  const $ = _c(31);
  const {
    icon: Icon,
    title,
    description,
    isSelected: t1,
    onClick,
    className,
    trend
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const WrapperComponent = onClick ? "button" : Slot;
  let t2;
  if ($[0] !== onClick) {
    t2 = onClick && {
      onClick,
      type: "button"
    };
    $[0] = onClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isSelected ? "border-primary bg-primary/5 hover:bg-primary/10" : "hover:bg-muted/50";
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = cn("h-[90px] relative overflow-hidden transition-colors py-3", t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== Icon || $[6] !== isSelected) {
    t5 = Icon && <div className={cn("shrink-0 rounded-lg p-2 bg-muted/60 mt-0.5", isSelected ? "bg-primary/10 text-primary" : "text-muted-foreground")}><Icon className="h-5 w-5" /></div>;
    $[5] = Icon;
    $[6] = isSelected;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== title) {
    t6 = <h4 className="text-base font-medium truncate">{title}</h4>;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== description) {
    t7 = <p className="text-sm text-muted-foreground truncate">{description}</p>;
    $[10] = description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7 || $[13] !== trend) {
    t8 = <div className="flex flex-row flex-wrap sm:items-center gap-x-2 gap-y-1 sm:justify-between">{t7}{trend}</div>;
    $[12] = t7;
    $[13] = trend;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="flex-1 min-w-0 text-left">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isSelected) {
    t10 = isSelected && <div className="shrink-0 mt-0.5"><Check className="size-4 text-primary" /></div>;
    $[18] = isSelected;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t9) {
    t11 = <CardContent className="p-3 h-full"><div className="flex items-start gap-3 h-full">{t5}{t9}{t10}</div></CardContent>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t4) {
    t12 = <Card className={t4}>{t11}</Card>;
    $[24] = t11;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== WrapperComponent || $[28] !== t12 || $[29] !== t2) {
    t13 = <WrapperComponent {...t2} className="group relative w-full h-full">{t12}</WrapperComponent>;
    $[27] = WrapperComponent;
    $[28] = t12;
    $[29] = t2;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}